import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Input, Select } from "antd";
import { Button, Modal } from "react-bootstrap";
import { Variant } from "../../types/Entities";
import { useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { Option } from "../../types/generics";

type Props = {
  variant?: Variant;
  onSubmit?: (values: any) => void;
  onClose?: () => void;
  loading: boolean;
  options?: Option[];
};

export default function VariantForm({
  onSubmit,
  onClose,
  variant,
  loading,
  options,
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (variant) form.setFieldsValue(variant);
  }, [variant, form]);

  return (
    <Form form={form} onFinish={onSubmit}>
      <Modal.Body>
        <Form.Item
          name="name"
          label="Nome Variante"
          rules={[
            {
              required: true,
              message: "Il nome della Variante è obbligatorio",
            },
          ]}
        >
          <Input placeholder="Nome Variante..." />
        </Form.Item>
        <Form.Item
          name="exerciseRef"
          label="Esercizio"
          rules={[
            {
              required: true,
              message: "L'Esercizio di appartenenza è obbligatorio",
            },
          ]}
        >
          <Select
            placeholder="Seleziona esercizio..."
            className="w-100"
            allowClear
          >
            {(options || []).map((exercise, index) => (
              <Select.Option
                key={index}
                value={exercise.value}
                label={exercise.label}
              >
                <span>{exercise.label}</span>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button
          variant="light"
          size="sm"
          className="border"
          onClick={onClose}
          disabled={loading}
        >
          {loading ? (
            <TailSpin width={15} height={15} color="#9c1419" />
          ) : (
            <span>Chiudi</span>
          )}
        </Button>
        <Button type="submit" variant="success" size="sm" disabled={loading}>
          {loading ? (
            <TailSpin width={15} height={15} color="#9c1419" />
          ) : (
            <>
              <FontAwesomeIcon icon={faSave} />
              <span className="ms-2">Salva</span>
            </>
          )}
        </Button>
      </Modal.Footer>
    </Form>
  );
}
